module.exports = __webpack_public_path__ + "img/icon-whatsapp-gray.6db0c833.svg";